import userGroupsTab from './userGroupsTab';
import userGroupCloneTab from './userGroupCloneTab';
import userGroupHistoryTab from './userGroupHistoryTab';
import newUserGroupTab from './newUserGroupTab';
import userGroupTab from './userGroupTab';

export default [
  newUserGroupTab,
  userGroupCloneTab,
  userGroupHistoryTab,
  userGroupsTab,
  userGroupTab,
];
